var yearRegExp = /^(1[2-9]\d\d|2\d\d\d|3000)$/;
export default (function (value) {
  var error = yearRegExp.test(value) ? '' : 'Year is invalid';
  return error;
});